import { Navigate, Route } from "react-router";
import { all_routes } from "./all_routes";
import { lazy, Suspense } from "react";
import HomeFourteen from "@/pages/home-modules/home-fourteen";
import HomeFifteen from "@/pages/home-modules/home-fifteen";
import Register from "@/pages/authentication/register";


const HomeSixteen = lazy(() => import("@/pages/home-modules/home-sixteen/homeSixteen"));
const HomeSeventeen = lazy(() => import("@/pages/home-modules/home-seventeen/homeSeventeen"));
const HomeEighteen = lazy(() => import("@/pages/home-modules/home-eighteen/homeEighteen"));
const HomeTen = lazy(() => import("@/pages/home-modules/home-ten/homeTen"));
const HomeEleven = lazy(() => import("@/pages/home-modules/home-eleven/homeEleven"));

const DoctorDashboard = lazy(() => import("@/pages/doctor-modules/doctor-dashboard/doctorDashboard"));
const DoctorRequest = lazy(() => import("@/pages/doctor-modules/doctor-request/doctorRequest"));
const Appointments = lazy(() => import("@/pages/doctor-modules/appointments/appointments"));
const DoctorAppointmentsGrid = lazy(() => import("@/pages/doctor-modules/appointments/doctorAppointmentsGrid"));
const DoctorUpcomingAppointment = lazy(() => import("@/pages/doctor-modules/appointments/doctorUpcomingAppointment"));
const DoctorAppointmentStart = lazy(() => import("@/pages/doctor-modules/appointments/doctorAppointmentStart"));

const AvailableTimings = lazy(() => import("@/pages/doctor-modules/available-timings/availableTimings"));
const MyPatients = lazy(() => import("@/pages/doctor-modules/my-patients/myPatients"));
const DoctorSpecialities = lazy(() => import("@/pages/doctor-modules/doctor-specialities/doctorSpecialities"));
const Reviews = lazy(() => import("@/pages/doctor-modules/reviews/reviews"));
const Accounts = lazy(() => import("@/pages/doctor-modules/accounts/accounts"));
const Invoices = lazy(() => import("@/pages/doctor-modules/invoices/invoices"));
const DoctorPayment = lazy(() => import("@/pages/doctor-modules/doctor-payment/doctorPayment"));
const ChatDoctor = lazy(() => import("@/pages/doctor-modules/chat-doctor/chatDoctor"));

const DoctorBlog = lazy(() => import("@/pages/doctor-modules/doctor-blog/doctorBlog"));
const DoctorPendingBlog = lazy(() => import("@/pages/doctor-modules/doctor-blog/doctorPendingBlog"));
const DoctorAddBlog = lazy(() => import("@/pages/doctor-modules/doctor-blog/doctorAddBlog"));
const EditBlog = lazy(() => import("@/pages/doctor-modules/doctor-blog/editBlog"));

const DoctorProfileSettings = lazy(() => import("@/pages/doctor-modules/doctor-settings/doctorProfileSettings"));
const DoctorExperienceSettings = lazy(() => import("@/pages/doctor-modules/doctor-settings/doctorExperienceSettings"));
const DoctorEducationSettings = lazy(() => import("@/pages/doctor-modules/doctor-settings/doctorEducationSettings"));
const DoctorAwardsSettings = lazy(() => import("@/pages/doctor-modules/doctor-settings/doctorAwardsSettings"));
const DoctorInsuranceSettings = lazy(() => import("@/pages/doctor-modules/doctor-settings/doctorInsuranceSettings"));
const DoctorClinicsSettings = lazy(() => import("@/pages/doctor-modules/doctor-settings/doctorClinicsSettings"));
const DoctorBusinessSettings = lazy(() => import("@/pages/doctor-modules/doctor-settings/doctorBusinessSettings"));

const SocialMedia = lazy(() => import("@/pages/doctor-modules/social-media/socialMedia"));
const DoctorChangePassword = lazy(() => import("@/pages/doctor-modules/doctor-change-password/doctorChangePassword"));

const PatientDashboard = lazy(() => import("@/pages/patient-module/patient-dashboard/patientDashboard"));
const PatientAppointment = lazy(() => import("@/pages/patient-module/patient-appointment/patientAppointment"));
const PatientCancelledAppointment = lazy(() => import("@/pages/patient-module/patient-appointment/patientCancelledAppointment"));
const PatientCompletedAppointment = lazy(() => import("@/pages/patient-module/patient-appointment/patientCompletedAppointment"));

const MapGrid = lazy(() => import("@/pages/patient-module/map-grid/mapGrid"));
const MapList = lazy(() => import("@/pages/patient-module/map-list/mapList"));

const DoctorSignup = lazy(() => import("@/pages/authentication/doctor-signup"));
const Signup = lazy(() => import("@/pages/authentication/signup"));
const PatientSignup = lazy(() => import("@/pages/authentication/patient-signup"));
const LoginEmail = lazy(() => import("@/pages/authentication/login/login-email"));
const ForgotPassword2 = lazy(() => import("@/pages/authentication/forgot-password2"));
const LoginEmailOtp = lazy(() => import("@/pages/authentication/login-email-otp"));
const LoginPhone = lazy(() => import("@/pages/authentication/login/login-phone"));
const Comingsoon = lazy(() => import("@/pages/authentication/coming soon"));
const Maintenance = lazy(() => import("@/pages/authentication/maintanence"));

const TermsCondition = lazy(() => import("@/pages/other-pages/terms-condition/termsCondition"));
const InvoiceView = lazy(() => import("@/pages/other-pages/invoice-view/invoiceView"));
const Components = lazy(() => import("@/pages/other-pages/components/components"));

const Error404 = lazy(() => import("@/pages/authentication/error-404/error404"));
const Error500 = lazy(() => import("@/pages/authentication/error-500/error500"));

const BlogList = lazy(() => import("@/pages/blog/bloglist"));
const BlogDetails = lazy(() => import("@/pages/blog/blogdetails"));
const BlogGrid = lazy(() => import("@/pages/blog/bloggrid"));

const BookingPopup = lazy(() => import("@/pages/patient-module/booking/bookingPopup"));
const DoctorGrid = lazy(() => import("@/pages/patient-module/doctorgrid/doctorGrid"));
const DoctorList = lazy(() => import("@/pages/patient-module/doctorlist/doctorList"));
const DoctorListAvailability = lazy(() => import("@/pages/patient-module/doctor-list-availability/doctorListAvailability"));

const Booking = lazy(() => import("@/pages/patient-module/booking/booking"));
const Booking1 = lazy(() => import("@/pages/patient-module/booking/booking1"));
const Booking2 = lazy(() => import("@/pages/patient-module/booking/booking2"));

const SearchDoctor = lazy(() => import("@/pages/patient-module/searchdoctor/search-doctor1"));
const SearchDoctor2 = lazy(() => import("@/pages/patient-module/searchdoctor/search-doctor2"));

const DoctorProfile = lazy(() => import("@/pages/patient-module/doctorprofile"));
const DoctorProfileTwo = lazy(() => import("@/pages/patient-module/doctorprofile2"));

const Checkout = lazy(() => import("@/pages/patient-module/checkout/checkout"));
const Favourites = lazy(() => import("@/pages/patient-module/favourites/favourites"));
const PatientChat = lazy(() => import("@/pages/patient-module/chat/patientChat"));

const Profile = lazy(() => import("@/pages/patient-module/settings/profile"));
const Password = lazy(() => import("@/pages/patient-module/settings/password"));
const TwoStepAuthentication = lazy(() => import("@/pages/patient-module/settings/two-step-authentication/twoStepAuthentication"));
const DeleteAccount = lazy(() => import("@/pages/patient-module/settings/delete-account/deleteAccount"));

const Dependent = lazy(() => import("@/pages/patient-module/dependent"));
const MedicalRecords = lazy(() => import("@/pages/patient-module/medicalrecords"));
const PatientAccounts = lazy(() => import("@/pages/patient-module/accounts"));
const PatientInvoice = lazy(() => import("@/pages/patient-module/patient-invoice"));
const MedicalDetails = lazy(() => import("@/pages/patient-module/medicaldetails"));

const PharmacyDetails = lazy(() => import("@/pages/pharmacy-module/pharmacy-details/pharmacyDetails"));
const PharmacySearch = lazy(() => import("@/pages/pharmacy-module/pharmacy-search/pharmacySearch"));
const ProductAll = lazy(() => import("@/pages/pharmacy-module/product-all/productAll"));
const ProductDescription = lazy(() => import("@/pages/pharmacy-module/product-description/productDescription"));
const Cart = lazy(() => import("@/pages/pharmacy-module/cart/cart"));
const ProductCheckout = lazy(() => import("@/pages/pharmacy-module/product-checkout/productCheckout"));
const PaymentSuccess = lazy(() => import("@/pages/pharmacy-module/payment-success/paymentSuccess"));
const PharmacyRegister = lazy(() => import("@/pages/pharmacy-module/pharmacy-register/pharmacyRegister"));

const AboutUs = lazy(() => import("@/pages/other-pages/about-us/aboutUs"));
const ContactUs = lazy(() => import("@/pages/other-pages/contact-us/contactUs"));
const Hospitals = lazy(() => import("@/pages/other-pages/hospitals/hospitals"));
const Speciality = lazy(() => import("@/pages/other-pages/speciality/speciality"));
const Clinic = lazy(() => import("@/pages/other-pages/clinic/clinic"));
const BlankPage = lazy(() => import("@/pages/other-pages/blank-page/blankPage"));
const Pricing = lazy(() => import("@/pages/other-pages/pricing/pricing"));
const Faq = lazy(() => import("@/pages/other-pages/faq/faq"));
const ForgotPassword = lazy(() => import("@/pages/authentication/forgot-password"));
const Terms = lazy(() => import("@/pages/other-pages/privacy-policy"));

const VoiceCall = lazy(() => import("@/pages/pharmacy-module/voice-call/voiceCall"));
const VideoCall = lazy(() => import("@/pages/other-pages/videocall"));


const HomeOne = lazy(() => import("../pages/home-modules/home-one/homeOne"));
const Login = lazy(() => import("../pages/authentication/login/login"));
const HomeTwo = lazy(() => import("../pages/home-modules/home-two/homeTwo"));
const HomeThree = lazy(
  () => import("../pages/home-modules/home-three/homeThree")
);
const HomeFour = lazy(() => import("@/pages/home-modules/home-four/homeFour"));
const HomeEight = lazy(
  () => import("@/pages/home-modules/home-eight/homeEight")
);
const HomeFive = lazy(() => import("@/pages/home-modules/home-five/homeFive"));
const HomeSix = lazy(() => import("@/pages/home-modules/home-six/homeSix"));
const HomeNine = lazy(() => import("@/pages/home-modules/home-nine/homeNine"));
const HomeSeven = lazy(
  () => import("@/pages/home-modules/home-seven/homeSeven")
);
const HomeTwelve = lazy(
  () => import("@/pages/home-modules/home-twelve/homeTwelve")
);
const HomeThirteen = lazy(
  () => import("@/pages/home-modules/home-thirteen/homeThirteen")
);

const route = all_routes;

const suspenseFallback = <div></div>;

export const publicRoutes = [
  {
    path: "/",
    name: "Root",
    element: <Navigate to={route.home} />,
    route: Route,
  },
  {
    id: "1",
    path: route.home,
    element: (
      <Suspense fallback={suspenseFallback}>
        <HomeOne />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "2",
    path: route.home2,
    element: (
      <Suspense fallback={suspenseFallback}>
        <HomeTwo />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "3",
    path: route.home3,
    element: (
      <Suspense fallback={suspenseFallback}>
        <HomeThree />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "4",
    path: route.home4,
    element: (
      <Suspense fallback={suspenseFallback}>
        <HomeFour />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "5",
    path: route.home5,
    element: (
      <Suspense fallback={suspenseFallback}>
        <HomeFive />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "6",
    path: route.home8,
    element: (
      <Suspense fallback={suspenseFallback}>
        <HomeEight />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "7",
    path: route.home6,
    element: (
      <Suspense fallback={suspenseFallback}>
        <HomeSix />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "8",
    path: route.home7,
    element: (
      <Suspense fallback={suspenseFallback}>
        <HomeSeven />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "9",
    path: route.home9,
    element: (
      <Suspense fallback={suspenseFallback}>
        <HomeNine />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "10",
    path: route.home10,
    element: (
      <Suspense fallback={suspenseFallback}>
        <HomeTen />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "11",
    path: route.home11,
    element: (
      <Suspense fallback={suspenseFallback}>
        <HomeEleven />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "12",
    path: route.home12,
    element: (
      <Suspense fallback={suspenseFallback}>
        <HomeTwelve />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "13",
    path: route.home13,
    element: (
      <Suspense fallback={suspenseFallback}>
        <HomeThirteen />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "14",
    path: route.pharmacyIndex,
    element: (
      <Suspense fallback={suspenseFallback}>
        <HomeThirteen />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "15",
    path: route.home14,
    element: (
      <Suspense fallback={suspenseFallback}>
        <HomeFourteen />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "16",
    path: route.home15,
    element: (
      <Suspense fallback={suspenseFallback}>
        <HomeFifteen />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "17",
    path: route.home16,
    element: (
      <Suspense fallback={suspenseFallback}>
        <HomeSixteen />
      </Suspense>
    ),
    route: Route,
    meta_title: "Home Doccure",
  },
  {
    id: "18",
    path: route.home17,
    element: (
      <Suspense fallback={suspenseFallback}>
        <HomeSeventeen />
      </Suspense>
    ),
    route: Route,
    meta_title: "Home Doccure",
  },
  {
    id: "19",
    path: route.home18,
    element: (
      <Suspense fallback={suspenseFallback}>
        <HomeEighteen />
      </Suspense>
    ),
    route: Route,
    meta_title: "Home Doccure",
  },
];

export const authRoutes = [
  {
    id: "1",
    path: route.login,
    element: (
      <Suspense fallback={suspenseFallback}>
        <Login />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "2",
    path: route.signup,
    element: (
      <Suspense fallback={suspenseFallback}>
        <Signup />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "3",
    path: route.doctorSignup,
    element: (
      <Suspense fallback={suspenseFallback}>
        <DoctorSignup />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "4",
    path: route.patientSignup,
    element: (
      <Suspense fallback={suspenseFallback}>
        <PatientSignup />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "5",
    path: route.loginEmail,
    element: (
      <Suspense fallback={suspenseFallback}>
        <LoginEmail />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "6",
    path: route.forgotPassword1,
    element: (
      <Suspense fallback={suspenseFallback}>
        <ForgotPassword />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "6",
    path: route.forgotPassword2,
    element: (
      <Suspense fallback={suspenseFallback}>
        <ForgotPassword2 />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "6",
    path: route.forgotPassword2,
    element: (
      <Suspense fallback={suspenseFallback}>
        <ForgotPassword2 />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "7",
    path: route.loginEmailOtp,
    element: (
      <Suspense fallback={suspenseFallback}>
        <LoginEmailOtp />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "8",
    path: route.loginPhoneOtp,
    element: (
      <Suspense fallback={suspenseFallback}>
        <LoginEmailOtp />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "9",
    path: route.loginPhone,
    element: (
      <Suspense fallback={suspenseFallback}>
        <LoginPhone />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },

  {
    id: "10",
    path: route.comingSoon,
    element: (
      <Suspense fallback={suspenseFallback}>
        <Comingsoon />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "11",
    path: route.maintenance,
    element: (
      <Suspense fallback={suspenseFallback}>
        <Maintenance />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "12",
    path: route.error404,
    element: (
      <Suspense fallback={suspenseFallback}>
        <Error404 />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "13",
    path: route.error500,
    element: (
      <Suspense fallback={suspenseFallback}>
        <Error500 />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "14",
    path: route.booking,
    element: (
      <Suspense fallback={suspenseFallback}>
        <Booking />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  
];
export const customLayout = [
  {
    id: "1",
    path: route.doctorDashboard,
    element: (
      <Suspense fallback={suspenseFallback}>
        <DoctorDashboard />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "2",
    path: route.doctorRequest,
    element: (
      <Suspense fallback={suspenseFallback}>
        <DoctorRequest />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "3",
    path: route.appointments,
    element: (
      <Suspense fallback={suspenseFallback}>
        <Appointments />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "4",
    path: route.doctorAppointmentsGrid,
    element: (
      <Suspense fallback={suspenseFallback}>
        <DoctorAppointmentsGrid />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "5",
    path: route.doctorUpcomingAppointment,
    element: (
      <Suspense fallback={suspenseFallback}>
        <DoctorUpcomingAppointment />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "6",
    path: route.doctorAppointmentsStart,
    element: (
      <Suspense fallback={suspenseFallback}>
        <DoctorAppointmentStart />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "7",
    path: route.doctorAvailableTimings,
    element: (
      <Suspense fallback={suspenseFallback}>
        <AvailableTimings />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "8",
    path: route.doctorMypatients,
    element: (
      <Suspense fallback={suspenseFallback}>
        <MyPatients />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "9",
    path: route.doctorSpecialities,
    element: (
      <Suspense fallback={suspenseFallback}>
        <DoctorSpecialities />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "10",
    path: route.reviews,
    element: (
      <Suspense fallback={suspenseFallback}>
        <Reviews />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "11",
    path: route.doctorAccounts,
    element: (
      <Suspense fallback={suspenseFallback}>
        <Accounts />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "12",
    path: route.invoiceList,
    element: (
      <Suspense fallback={suspenseFallback}>
        <Invoices />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "13",
    path: route.doctorPayment,
    element: (
      <Suspense fallback={suspenseFallback}>
        <DoctorPayment />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "14",
    path: route.doctorChat,
    element: (
      <Suspense fallback={suspenseFallback}>
        <ChatDoctor />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "15",
    path: route.doctorBlog,
    element: (
      <Suspense fallback={suspenseFallback}>
        <DoctorBlog />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "15",
    path: route.doctorPendingBlog,
    element: (
      <Suspense fallback={suspenseFallback}>
        <DoctorPendingBlog />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "16",
    path: route.doctorAddBlog,
    element: (
      <Suspense fallback={suspenseFallback}>
        <DoctorAddBlog />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "17",
    path: route.editBlog,
    element: (
      <Suspense fallback={suspenseFallback}>
        <EditBlog />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "18",
    path: route.doctorProfileSettings,
    element: (
      <Suspense fallback={suspenseFallback}>
        <DoctorProfileSettings />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "19",
    path: route.doctorExperienceSettings,
    element: (
      <Suspense fallback={suspenseFallback}>
        <DoctorExperienceSettings />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "20",
    path: route.doctorEducationSettings,
    element: (
      <Suspense fallback={suspenseFallback}>
        <DoctorEducationSettings />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "21",
    path: route.doctorAwardsSettings,
    element: (
      <Suspense fallback={suspenseFallback}>
        <DoctorAwardsSettings />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "22",
    path: route.doctorInsuranceSettings,
    element: (
      <Suspense fallback={suspenseFallback}>
        <DoctorInsuranceSettings />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "23",
    path: route.doctorClinicsSettings,
    element: (
      <Suspense fallback={suspenseFallback}>
        <DoctorClinicsSettings />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "24",
    path: route.doctorBusinessSettings,
    element: (
      <Suspense fallback={suspenseFallback}>
        <DoctorBusinessSettings />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "25",
    path: route.doctorSocialMedia,
    element: (
      <Suspense fallback={suspenseFallback}>
        <SocialMedia />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "26",
    path: route.doctorChangePassword,
    element: (
      <Suspense fallback={suspenseFallback}>
        <DoctorChangePassword />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "25",
    path: route.patientDashboard,
    element: (
      <Suspense fallback={suspenseFallback}>
        <PatientDashboard />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
];
export const commonLayout = [
  {
    id: "1",
    path: route.patientAppointments,
    element: (
      <Suspense fallback={suspenseFallback}>
        <PatientAppointment />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "2",
    path: route.patientCancelAppointments,
    element: (
      <Suspense fallback={suspenseFallback}>
        <PatientCancelledAppointment />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "3",
    path: route.patientCompletedAppointments,
    element: (
      <Suspense fallback={suspenseFallback}>
        <PatientCompletedAppointment />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "4",
    path: route.mapGrid,
    element: (
      <Suspense fallback={suspenseFallback}>
        <MapGrid />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "5",
    path: route.mapList,
    element: (
      <Suspense fallback={suspenseFallback}>
        <MapList />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "6",
    path: route.termsAndCondition,
    element: (
      <Suspense fallback={suspenseFallback}>
        <TermsCondition />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "7",
    path: route.invoiceView,
    element: (
      <Suspense fallback={suspenseFallback}>
        <InvoiceView />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "8",
    path: route.components,
    element: (
      <Suspense fallback={suspenseFallback}>
        <Components />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "9",
    path: route.blogList,
    element: (
      <Suspense fallback={suspenseFallback}>
        <BlogList />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "10",
    path: route.blogDetails,
    element: (
      <Suspense fallback={suspenseFallback}>
        <BlogDetails />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "11",
    path: route.blogGrid,
    element: (
      <Suspense fallback={suspenseFallback}>
        <BlogGrid />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "12",
    path: route.bookingPopup,
    element: (
      <Suspense fallback={suspenseFallback}>
        <BookingPopup />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "13",
    path: route.doctorsGrid,
    element: (
      <Suspense fallback={suspenseFallback}>
        <DoctorGrid />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "14",
    path: route.doctorsList,
    element: (
      <Suspense fallback={suspenseFallback}>
        <DoctorList />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "15",
    path: route.doctorListAvailability,
    element: (
      <Suspense fallback={suspenseFallback}>
        <DoctorListAvailability />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  
  {
    id: "17",
    path: route.booking1,
    element: (
      <Suspense fallback={suspenseFallback}>
        <Booking1 />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "18",
    path: route.booking2,
    element: (
      <Suspense fallback={suspenseFallback}>
        <Booking2 />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "19",
    path: route.search1,
    element: (
      <Suspense fallback={suspenseFallback}>
        <SearchDoctor />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "20",
    path: route.search2,
    element: (
      <Suspense fallback={suspenseFallback}>
        <SearchDoctor2 />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "21",
    path: route.doctorProfile1,
    element: (
      <Suspense fallback={suspenseFallback}>
        <DoctorProfile />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "22",
    path: route.doctorProfile2,
    element: (
      <Suspense fallback={suspenseFallback}>
        <DoctorProfileTwo />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "23",
    path: route.checkout,
    element: (
      <Suspense fallback={suspenseFallback}>
        <Checkout />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "24",
    path: route.favourites,
    element: (
      <Suspense fallback={suspenseFallback}>
        <Favourites />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "25",
    path: route.chat,
    element: (
      <Suspense fallback={suspenseFallback}>
        <PatientChat />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "26",
    path: route.patientProfileSettings,
    element: (
      <Suspense fallback={suspenseFallback}>
        <Profile />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "27",
    path: route.patientChangePassword,
    element: (
      <Suspense fallback={suspenseFallback}>
        <Password />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "28",
    path: route.patientTwoFactor,
    element: (
      <Suspense fallback={suspenseFallback}>
        <TwoStepAuthentication />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "29",
    path: route.patientDeleteAccount,
    element: (
      <Suspense fallback={suspenseFallback}>
        <DeleteAccount />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "30",
    path: route.patientDependants,
    element: (
      <Suspense fallback={suspenseFallback}>
        <Dependent />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "31",
    path: route.patientMedicalRecords,
    element: (
      <Suspense fallback={suspenseFallback}>
        <MedicalRecords />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "32",
    path: route.patientAccounts,
    element: (
      <Suspense fallback={suspenseFallback}>
        <PatientAccounts />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "33",
    path: route.patientInvoices,
    element: (
      <Suspense fallback={suspenseFallback}>
        <PatientInvoice />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "34",
    path: route.patientMedicalDetails,
    element: (
      <Suspense fallback={suspenseFallback}>
        <MedicalDetails />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "35",
    path: route.pharmacyDetails,
    element: (
      <Suspense fallback={suspenseFallback}>
        <PharmacyDetails />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "36",
    path: route.pharmacySearch,
    element: (
      <Suspense fallback={suspenseFallback}>
        <PharmacySearch />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "37",
    path: route.productAll,
    element: (
      <Suspense fallback={suspenseFallback}>
        <ProductAll />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "38",
    path: route.productDescription,
    element: (
      <Suspense fallback={suspenseFallback}>
        <ProductDescription />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "39",
    path: route.cart,
    element: (
      <Suspense fallback={suspenseFallback}>
        <Cart />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "40",
    path: route.productCheckout,
    element: (
      <Suspense fallback={suspenseFallback}>
        <ProductCheckout />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "41",
    path: route.paymentSuccess,
    element: (
      <Suspense fallback={suspenseFallback}>
        <PaymentSuccess />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "42",
    path: route.pharmacyRegister,
    element: (
      <Suspense fallback={suspenseFallback}>
        <PharmacyRegister />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "43",
    path: route.aboutUs,
    element: (
      <Suspense fallback={suspenseFallback}>
        <AboutUs />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "44",
    path: route.contactUs,
    element: (
      <Suspense fallback={suspenseFallback}>
        <ContactUs />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "45",
    path: route.hospitals,
    element: (
      <Suspense fallback={suspenseFallback}>
        <Hospitals />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "46",
    path: route.speciality,
    element: (
      <Suspense fallback={suspenseFallback}>
        <Speciality />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "47",
    path: route.clinics,
    element: (
      <Suspense fallback={suspenseFallback}>
        <Clinic />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "48",
    path: route.starterPage,
    element: (
      <Suspense fallback={suspenseFallback}>
        <BlankPage />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "49",
    path: route.pricing,
    element: (
      <Suspense fallback={suspenseFallback}>
        <Pricing />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "50",
    path: route.faq,
    element: (
      <Suspense fallback={suspenseFallback}>
        <Faq />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "51",
    path: route.privacyPolicy,
    element: (
      <Suspense fallback={suspenseFallback}>
        <Terms />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "52",
    path: route.voiceCall,
    element: (
      <Suspense fallback={suspenseFallback}>
        <VoiceCall />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "53",
    path: route.videoCall,
    element: (
      <Suspense fallback={suspenseFallback}>
        <VideoCall />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
  {
    id: "54",
    path: route.register,
    element: (
      <Suspense fallback={suspenseFallback}>
        <Register />
      </Suspense>
    ),
    route: Route,
    meta_title: "Doccure",
  },
];
